import { render } from "./CobraStatements.vue?vue&type=template&id=36954d81&ts=true"
import script from "./CobraStatements.vue?vue&type=script&lang=ts"
export * from "./CobraStatements.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__